<div class="image_container">
    <img mat-card-image [src]="image.imageUrl" [alt]="image.title">
</div>
